import React from "react";
import { HelperManager, type HelperType, type HelpItem } from "./HelperManager";
import { HelperUI } from "./HelperUI";

export const useHelper = (
  refUid: string,
  helperType: HelperType,
  items: HelpItem[],
) => {
  const [m] = React.useState(() => new HelperManager(helperType, refUid));

  React.useEffect(() => {
    m.updateItems(items);
  }, [m, items]);

  if (!m.isVisible) {
    return null;
  }

  return <HelperUI manager={m} />;
};
